import { useEffect } from "react";
import { Navigate, useParams } from "react-router";
import { useChatPanelStore } from "stores/chatPanel";

export const ChatRedirect: React.FC = () => {
  const { discussionId } = useParams<{ discussionId: string }>();

  const setPanelDiscussionId = useChatPanelStore(
    store => store.setPanelDiscussionId
  );

  useEffect(() => {
    if (discussionId) setPanelDiscussionId(discussionId);
  }, [discussionId, setPanelDiscussionId]);

  return <Navigate to="/home" replace />;
};
